<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      no-filters
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:assigned="{ item }">
        <div>
          {{ item?.product_tiers?.map(r=> r.product_name)?.join(", ") }}
        </div>
      </template>


      <template v-slot:actions="{ item }">
        <v-icon
          v-if="item.product_tiers?.map(r=> r.product_name).length>0 && isCreate"
          class="mr-2 cursor-pointer"
          small
          @click="unassignItem(item)"
        >
          mdi-link-variant-off
        </v-icon>
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <div class="d-flex gap-5"> 
            <assign-product-tier-modal
              v-if="isCreate"
              :filter-options="options"
            />
            <unassign-product-tier-modal
              v-if="(isEdit ) && isUnassign"
              :is-visible-dialog="isUnassign"
              :toggle-edit="toggleUnassignModal"
              :item="selectedRow"
            />
            <create-tier
              v-if="isCreate"
              :filter-options="options"
            />
          </div>

          <edit-tier
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
          <!-- <confirmation-modal
            v-if="isUnassign"
            :is-visible="isUnassign"
            :toggle="toggleUnassignModal"
            :row="selectedRow"
            msg="Are you sure to Unassign"
          /> -->
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateTier: () => import("./dialogs/CreateTier.vue"),
    EditTier: () => import("./dialogs/EditTier.vue"),
    AssignProductTierModal: () => import("./dialogs/AssignProductTier.vue"),
    UnassignProductTierModal: () => import("./dialogs/UnassignProductTier.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      permissions: {
        view: "roles.view",
        create: "roles.create",
        edit: "roles.edit",
        delete: "roles.delete",
      },
      filters: {},
      subFilters: {},
      // 
      isUnassign: false

    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "productTiers/getLoading",
      meta: "productTiers/getMeta",
      list: "productTiers/getList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
       
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "name",
        },
         {
          text: this.$t("assigned"),
          align: "left",
          sortable: false,
          value: "assigned",
        },
        {
          text: this.$t("created_at"),
          align: "left",
          sortable: false,
          value: "created_at",
        },
        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {
    // this.$store.dispatch("csmsChargeStations/setLoadingValue", true);
  },
  beforeDestroy() {
    const params = {
      name: "product_tiers",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };
      await this.$store.dispatch("productTiers/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    unassignItem(row){
      this.selectedRow = row
      this.isUnassign = true
    },
    async toggleUnassignModal(val){
      if(val == 'ok'){
        await this.$store.dispatch("productTiers/unassign",this.selectedRow);
        this.isUnassign= false
        this.$store.dispatch("alerts/success", this.$t("unassigned_successfully"));
      }
      else this.isUnassign = false
    },
    
    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("productTiers/destroy", row)
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        // if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
        //   this.options.page -= 1; // Move to the previous page
        // }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },


  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
